import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fa347b54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-gray-900 py-10" }
const _hoisted_2 = { class: "container mx-auto px-6 lg:px-12" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "Contact Us", -1))
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Address:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Tel:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fax:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "CONTACT US 7/24", -1))
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/mail.png",
  class: "h-6 pr-2"
}, null, -1))
const _hoisted_12 = ["href"]
const _hoisted_13 = { id: "contactus" }
const _hoisted_14 = { class: "space-y-2" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "text-center mt-8 text-gray-400 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.contactInfo.address), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.contactInfo.tel), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.contactInfo.fax), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (data, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "flex"
              }, [
                _hoisted_11,
                _createTextVNode(),
                _createElementVNode("a", {
                  href: `mailto:${data.mail}`,
                  class: "font-medium w-36"
                }, _toDisplayString(data.mail), 9, _hoisted_12)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (data, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "flex"
              }, [
                _createElementVNode("a", {
                  href: data.url,
                  class: "font-medium"
                }, _toDisplayString(data.text), 9, _hoisted_15)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, " © " + _toDisplayString(new Date().getFullYear()) + " All Rights Reserved. ", 1)
    ])
  ]))
}